(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('nasrac-customer-report', {
            parent: 'reports',
            url: '/nasrac-customer-report',
            data: {
                authorities: ['Administrators', 'DAC Content Administrator', 'DAC Content User', 'Customer Users'],
                pageTitle: 'nasracApp.nasracCustomerReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/nasrac-customer-report/nasrac-customer-reports.html',
                    controller: 'NasracCustomerReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nasracCustomerReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
